import styles from './BaseTable.module.scss';

type Props = {
  children: any;
  id?: string
  className?: string;
  borderless?: boolean;
  isDiscoverTable?: boolean;
};

const BaseTable = ({ id, children, className, borderless = false, isDiscoverTable }: Props) => (
  <table id={id} className={[isDiscoverTable ? styles.discoverTable : styles.table, className].join(' ')}>
    { children }
  </table>
);

export default BaseTable;
